(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[281],{

/***/ 3323:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anuncio/[category]/[vehicle]/[year]/[id]",
      function () {
        return __webpack_require__(2003);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FallBackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const FallBackImage = (param)=>{
    let { src , alt , ...rest } = param;
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(src);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setImgSrc(src);
    }, [
        src
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        ...rest,
        alt: alt,
        fill: true,
        src: imgSrc ? imgSrc : "/img/no-image.jpeg",
        onError: ()=>{
            setImgSrc("/img/no-image.jpeg");
        }
    });
};


/***/ }),

/***/ 2003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ VehicleDetailsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./src/components/default/fallback-image.js
var fallback_image = __webpack_require__(2908);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(2167);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-input-mask/index.js
var react_input_mask = __webpack_require__(6627);
var react_input_mask_default = /*#__PURE__*/__webpack_require__.n(react_input_mask);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./services/api.js + 41 modules
var api = __webpack_require__(8382);
// EXTERNAL MODULE: ./node_modules/next-recaptcha-v3/lib/index.esm.js
var lib_index_esm = __webpack_require__(8657);
// EXTERNAL MODULE: ./node_modules/react-sticky-box/dist/index.js
var dist = __webpack_require__(7134);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/index.js + 8 modules
var yet_another_react_lightbox_dist = __webpack_require__(1227);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/index.js + 3 modules
var fullscreen = __webpack_require__(9178);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/index.js + 5 modules
var thumbnails = __webpack_require__(2806);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/zoom/index.js + 6 modules
var zoom = __webpack_require__(4500);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/styles.css
var styles = __webpack_require__(5737);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css
var thumbnails_thumbnails = __webpack_require__(925);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(9901);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/car-details/car-details-form.js



















// import { Button, Modal } from "react-bootstrap";
function CarDetails(param) {
    let { ad , company  } = param;
    const [formPost, setFormPost] = (0,react.useState)({
        isLoading: false,
        isError: false,
        errorText: "",
        isSuccess: false
    });
    const [index, setIndex] = (0,react.useState)(-1);
    const [openYoutubeVideo, setOpenYoutubeVideo] = (0,react.useState)(false);
    const [thumbsSwiper, setThumbsSwiper] = (0,react.useState)(null);
    // const [showFinancingModal, setShowFinancingModal] = useState({ isOpen: false });
    const { register , handleSubmit , formState: { errors  } , setValue  } = (0,index_esm/* useForm */.cI)();
    const { executeRecaptcha  } = (0,lib_index_esm/* useReCaptcha */.CL)();
    const onSubmit = async (data)=>{
        const token = await executeRecaptcha("proposalSubmit");
        setFormPost({
            ...formPost,
            isLoading: true,
            isError: false,
            errorText: "",
            isSuccess: false
        });
        (0,api/* fetchPostEmailSendPurpose */.rd)({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            idAd: ad.id,
            token
        }).then((res)=>{
            if (res) {
                setValue("txtName", "");
                setValue("txtEmail", "");
                setValue("txtCellPhone", "");
                setValue("txtMessage", "");
                setFormPost({
                    ...formPost,
                    isLoading: false,
                    isSuccess: true
                });
            }
        }).catch((err)=>{
            setFormPost({
                ...formPost,
                isLoading: false,
                isError: true,
                errorText: err.toString()
            });
        });
    };
    var _mileage, _price, _mileage1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "inventory-details-area ptb-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xl-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "inventory-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "product_details widget-padding bg-white rounded",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "btn-meta bg-primary text-white",
                                                    children: "".concat(ad.category, " - ").concat(ad.condition.replace("-", ""))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "mt-2",
                                                    children: "".concat(ad.brand, " ").concat(ad.model, " ").concat(ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), "") : "")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "iv-meta",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fa-solid fa-clock"
                                                            }),
                                                            "anunciado em: ",
                                                            (0,format/* default */.Z)(new Date(ad.datetime), "dd/MM/yyyy")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "iv_double_slider mt-30",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "iv_thumb_slider swiper",
                                                            children: [
                                                                ad.videos.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "watch-video-button",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        id: "video-popup-btn",
                                                                        onClick: ()=>setOpenYoutubeVideo(true),
                                                                        href: "#",
                                                                        title: "".concat(ad.brand, " ").concat(ad.model, " ").concat(ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), "") : ""),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fas fa-play watch-video-button-i"
                                                                            }),
                                                                            "Video do Ve\xedculo"
                                                                        ]
                                                                    })
                                                                }) : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                                    slidesPerView: 1,
                                                                    navigation: true,
                                                                    thumbs: {
                                                                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                                                                    },
                                                                    modules: [
                                                                        swiper_esm/* Thumbs */.o3,
                                                                        swiper_esm/* Navigation */.W_,
                                                                        swiper_esm/* FreeMode */.Rv
                                                                    ],
                                                                    children: ad.photos.length > 0 ? ad.photos.map((photo, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                            className: "swiper-slide thumb-wrapper rounded overflow-hidden",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                onClick: ()=>setIndex(index),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    src: photo,
                                                                                    alt: "carro",
                                                                                    width: 808,
                                                                                    height: 490,
                                                                                    sizes: "100vw",
                                                                                    style: {
                                                                                        width: "100%",
                                                                                        height: "auto",
                                                                                        objectFit: "cover"
                                                                                    }
                                                                                })
                                                                            })
                                                                        }, index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                        className: "swiper-slide thumb-wrapper rounded overflow-hidden",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/img/no-image.jpeg",
                                                                            alt: "Sem imagem dispon\xedvel",
                                                                            width: 808,
                                                                            height: 490,
                                                                            sizes: "100vw",
                                                                            style: {
                                                                                width: "100%",
                                                                                height: "auto"
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        ad.photos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "iv_thumb_control_slider swiper mt-3 mt-lg-4",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                                onSwiper: setThumbsSwiper,
                                                                spaceBetween: 24,
                                                                slidesPerView: 4,
                                                                freeMode: true,
                                                                watchSlidesProgress: true,
                                                                breakpoints: {
                                                                    [0]: {
                                                                        slidesPerView: 3,
                                                                        spaceBetween: 16
                                                                    },
                                                                    [992]: {
                                                                        slidesPerView: 4,
                                                                        spaceBetween: 24
                                                                    }
                                                                },
                                                                modules: [
                                                                    swiper_esm/* Thumbs */.o3,
                                                                    swiper_esm/* Navigation */.W_,
                                                                    swiper_esm/* FreeMode */.Rv
                                                                ],
                                                                children: ad.photos.length > 0 ? ad.photos.map((photo, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                        className: "swiper-slide rounded overflow-hidden",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: photo,
                                                                            alt: "carro",
                                                                            className: "img-slide-thumb-fluid",
                                                                            width: 283,
                                                                            height: 187
                                                                        })
                                                                    }, index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "swiper-slide rounded overflow-hidden",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: "/img/no-image.jpeg",
                                                                        alt: "carro",
                                                                        width: 283,
                                                                        height: 187,
                                                                        sizes: "100vw",
                                                                        style: {
                                                                            width: "100%",
                                                                            height: "auto"
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "product_info bg-white rounded widget-padding mt-30",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "mb-5",
                                                    children: "Caracter\xedsticas"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row g-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-car"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Tipo"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: ad.condition
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-gauge"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Quilometragem"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                                    value: (_mileage = ad.mileage) !== null && _mileage !== void 0 ? _mileage : 0,
                                                                                    displayType: "text",
                                                                                    thousandSeparator: ".",
                                                                                    decimalSeparator: ","
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-gears"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "C\xe2mbio"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: ad.transmission
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-palette"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Cor"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: ad.color
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-calendar"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Ano"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: "".concat(ad.yearFabrication, "/").concat(ad.yearModel)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-gas-pump"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Combust\xedvel"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: ad.fuel
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "22",
                                                                            height: "22",
                                                                            viewBox: "0 0 200 200",
                                                                            fill: "currentColor",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                                                transform: "translate(0,200) scale(0.1,-0.1)",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M765 1851 c-16 -10 -161 -148 -321 -307 -248 -246 -293 -295 -303 -330 -7 -28 -11 -211 -11 -573 l0 -531 905 0 905 0 0 880 0 880 -572 0 c-540 0 -575 -1 -603 -19z m1025 -441 l0 -320 -725 0 c-799 0 -785 -1 -785 58 0 15 4 32 8 37 4 6 129 130 278 278 l270 267 477 0 477 0 0 -320z m-49 -580 c23 -13 25 -43 3 -64 -12 -13 -38 -16 -120 -16 -58 0 -113 4 -123 10 -28 14 -34 40 -15 61 15 16 33 19 126 19 60 0 118 -5 129 -10z"
                                                                                })
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Portas"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: ad.doors ? "".concat(ad.doors, " portas") : "-"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-3 col-md-4 col-sm-6",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "iv_info_item d-flex align-items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-shield"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "info_content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "meta",
                                                                                children: "Blindado"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "title",
                                                                                children: ad.armored ? "Sim" : "N\xe3o"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "mt-30 mb-30"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "iv_sidebar_widget iv_pricing_widget widget-padding bg-primary rounded",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                            className: "mb-2 text-white",
                                                            children: [
                                                                ad.promotionalPrice ? ad.price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    style: {
                                                                        color: "white",
                                                                        fontSize: "14px",
                                                                        textDecoration: "line-through"
                                                                    },
                                                                    value: (_price = ad.price) !== null && _price !== void 0 ? _price : 0,
                                                                    displayType: "text",
                                                                    thousandSeparator: ".",
                                                                    decimalSeparator: ",",
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true,
                                                                    prefix: "De R$ "
                                                                }) : "Consulte-nos" : null,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        ad.price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            style: {
                                                                                color: "#fff"
                                                                            },
                                                                            value: ad.promotionalPrice ? ad.promotionalPrice : ad.price,
                                                                            displayType: "text",
                                                                            thousandSeparator: ".",
                                                                            decimalSeparator: ",",
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true,
                                                                            prefix: "".concat(ad.promotionalPrice ? "Por R$ " : "R$ ")
                                                                        }) : "Consulte-nos",
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "widget_meta d-flex align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "text-white",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa-solid fa-gauge-high"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            value: (_mileage1 = ad.mileage) !== null && _mileage1 !== void 0 ? _mileage1 : 0,
                                                                            displayType: "text",
                                                                            thousandSeparator: ".",
                                                                            decimalSeparator: ",",
                                                                            suffix: " km"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "text-white",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa-solid fa-eye"
                                                                        }),
                                                                        "".concat(company.city, " - ").concat(company.federativeUnit)
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "mt-40 mb-30"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "mb-40",
                                                    children: "Sobre o Ve\xedculo"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                                                    className: "formatted-text",
                                                    children: ad.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "mt-30 mb-30"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "mb-30",
                                                    children: "Opcionais / Itens de S\xe9rie"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: ad.optionals.map((optional, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-sm-4",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "iv_ft_list",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "me-2",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa-solid fa-check"
                                                                            })
                                                                        }),
                                                                        optional
                                                                    ]
                                                                })
                                                            })
                                                        }, index))
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                    className: "mt-30 mb-30"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "mb-4",
                                                    children: "Localiza\xe7\xe3o"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "map-frame rounded overflow-hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                        src: "https://maps.google.com/maps?q=".concat(company.address, " - ").concat(company.city, " - ").concat(company.federativeUnit, " - ").concat(company.postalCode, "&t=&z=13&ie=UTF8&iwloc=&output=embed"),
                                                        style: {
                                                            border: 0,
                                                            width: "100%",
                                                            height: "400px"
                                                        },
                                                        allowFullScreen: true,
                                                        loading: "lazy"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-xl-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    offsetTop: 140,
                                    offsetBottom: 20,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "iv_sidebar mt-5 mt-xl-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "iv_sidebar_widget iv_seller_widget widget-padding bg-white rounded mt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "mb-30",
                                                    children: "Envie uma proposta"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                    onSubmit: handleSubmit(onSubmit),
                                                    className: "seller_offer_form",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "row g-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "input-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                children: "Nome"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "text",
                                                                                ...register("txtName", {
                                                                                    required: true
                                                                                }),
                                                                                required: errors.txtName
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "input-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                children: "Email"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                type: "email",
                                                                                ...register("txtEmail", {
                                                                                    required: true,
                                                                                    pattern: /^\S+@\S+$/i
                                                                                }),
                                                                                required: errors.txtEmail
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "input-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                children: "Celular"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_input_mask_default()), {
                                                                                type: "tel",
                                                                                mask: "(99) 99999-9999",
                                                                                maskChar: " ",
                                                                                ...register("txtCellPhone", {
                                                                                    required: true
                                                                                }),
                                                                                required: errors.txtCellPhone
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-12",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "input-field",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                                children: "Mensagem"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                                                ...register("txtMessage", {
                                                                                    required: true
                                                                                }),
                                                                                required: errors.txtMessage,
                                                                                defaultValue: "Ol\xe1 gostaria de mais informa\xe7\xf5es sobre o ve\xedculo ".concat(ad.brand, " ").concat(ad.model, " ").concat(ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), "") : "", " - ").concat(ad.yearModel)
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        formPost.isError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "row mt-4",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "error-badge bg-primary-light rounded d-block",
                                                                    children: formPost.errorText
                                                                })
                                                            })
                                                        }) : null,
                                                        formPost.isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "row mt-4",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "success-badge bg-primary-success rounded d-block",
                                                                    children: "Proposta enviada com sucesso!"
                                                                })
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "row g-2",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        type: "submit",
                                                                        disabled: formPost.isLoading,
                                                                        style: {
                                                                            width: "100%"
                                                                        },
                                                                        className: "btn btn-secondary btn-md mt-30",
                                                                        children: "Enviar Proposta"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "col-6",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                        type: "button",
                                                                        className: "btn btn-primary-whatsapp btn-md mt-30",
                                                                        style: {
                                                                            width: "100%"
                                                                        },
                                                                        onClick: ()=>{
                                                                            const message = "Ol\xe1 gostaria de mais informa\xe7\xf5es sobre o ve\xedculo ".concat(ad.brand, " ").concat(ad.model, " ").concat(ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), "") : "", " - ").concat(ad.yearModel);
                                                                            window.open("https://api.whatsapp.com/send?phone=+55".concat(company.whatsapp, "&text=").concat(company.whatsappDetailsMessage ? company.whatsappDetailsMessage : message, " - ").concat(window.location.href, "}}}"));
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "me-2",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fa-brands fa-whatsapp"
                                                                                })
                                                                            }),
                                                                            "WhatsApp"
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(yet_another_react_lightbox_dist/* default */.Z, {
                open: index >= 0,
                index: index,
                close: ()=>setIndex(-1),
                slides: ad.photos.map((item)=>({
                        src: item
                    })),
                plugins: [
                    fullscreen/* default */.Z,
                    thumbnails/* default */.Z,
                    zoom/* default */.ZP
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(yet_another_react_lightbox_dist/* default */.Z, {
                open: openYoutubeVideo,
                close: ()=>setOpenYoutubeVideo(false),
                slides: [
                    {
                        type: "youtube",
                        src: ad.videos[0]
                    }
                ],
                render: {
                    slide: (param)=>{
                        let { type , src  } = param;
                        return type === "youtube" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            style: {
                                width: "100%",
                                height: "100%"
                            },
                            src: src,
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true
                        }) : null;
                    }
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/layout/footer.js
var footer = __webpack_require__(9432);
// EXTERNAL MODULE: ./src/components/layout/header.js
var header = __webpack_require__(392);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./utils/utils.js
function capitalize(word) {
    const arr = word.split(" ");
    for(var i = 0; i < arr.length; i++){
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const str2 = arr.join(" ");
    return str2;
}

;// CONCATENATED MODULE: ./src/pages/anuncio/[category]/[vehicle]/[year]/[id].js







var __N_SSP = true;
function VehicleDetailsPage(param) {
    let { companyGeneralData , ad  } = param;
    const router = (0,next_router.useRouter)();
    companyGeneralData = JSON.parse(companyGeneralData);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Est\xe1 procurando por ".concat(capitalize(router.query.vehicle), " - ").concat(router.query.year, "?, veja essa e outras op\xe7\xf5es dispon\xedveis em nosso estoque")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "https://bndv.com.br"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(companyGeneralData.company.nickName, " - ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", " - ").concat(capitalize(router.query.vehicle.replace("-", " ")), " - ").concat(router.query.year)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        company: companyGeneralData.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarDetails, {
                        ad: ad,
                        company: companyGeneralData.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {
                        company: companyGeneralData.company
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,333,536,297,371,822,774,888,179], function() { return __webpack_exec__(3323); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);